export const PlusIcon = ({ className = 'w-[25px] h-[25px]', fill="#D4002A", stroke="white" }) => {
  return (
    <svg
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2081_14067)">
        <path
          d="M12.6328 24.0156C19.2602 24.0156 24.6328 18.643 24.6328 12.0156C24.6328 5.38821 19.2602 0.015625 12.6328 0.015625C6.0054 0.015625 0.632812 5.38821 0.632812 12.0156C0.632812 18.643 6.0054 24.0156 12.6328 24.0156Z"
          fill={fill}
        />
        <path
          d="M7.63281 12.0156H17.6328"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6328 17.0156L12.6328 7.01562"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2081_14067">
          <rect
            width="24"
            height="24"
            fill={stroke}
            transform="translate(0.632812 0.015625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
